import React from "react";
import SiteNav from "@/components/site/SiteNav";
import SiteFooter from "@/components/site/SiteFooter";
import { useI18n } from "@/contexts/I18nContext";
import { IconInfinity } from "@tabler/icons-react";

export default function SiteAbout() {
  const { t } = useI18n();
  const values = t("about.values");

  return (
    <div className="bg-paper">
      <SiteNav />
      <section className="py-20">
        <div className="wrap grid md:grid-cols-2 gap-12">
          <div>
            <p className="eyebrow">{t("about.mission_eye")}</p>
            <h2 className="font-display font-medium text-[clamp(26px,4vw,36px)] mt-2">
              {t("about.mission_title")}
            </h2>
          </div>
          <div>
            <p className="font-display text-[24px] font-medium leading-snug">
              {t("about.mission_big")}
            </p>
            <p className="text-muted text-[14.5px] mt-5 leading-relaxed">{t("about.mission_body")}</p>
          </div>
        </div>
      </section>
      <section className="py-20 border-t border-line bg-white">
        <div className="wrap grid md:grid-cols-2 gap-12">
          <div>
            <p className="eyebrow">{t("about.vision_eye")}</p>
            <h2 className="font-display font-medium text-[clamp(26px,4vw,36px)] mt-2">
              {t("about.vision_title")}
            </h2>
          </div>
          <div>
            <p className="font-display text-[24px] font-medium leading-snug">{t("about.vision_big")}</p>
            <p className="text-muted text-[14.5px] mt-5 leading-relaxed">{t("about.vision_body")}</p>
          </div>
        </div>
      </section>
      <section className="py-20 border-t border-line">
        <div className="wrap">
          <p className="eyebrow">{t("about.values_eye")}</p>
          <h2 className="font-display font-medium text-[clamp(26px,4vw,36px)] mt-2 mb-10">
            {t("about.values_title")}
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {values.map((v, i) => (
              <div key={i} className="card">
                <h3 className="font-display text-[18px] font-medium">{v.t}</h3>
                <p className="text-muted text-[14px] mt-3 leading-relaxed">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-20 border-t border-line bg-white">
        <div className="wrap">
          <div className="flex items-center gap-3 mb-4">
            <IconInfinity size={20} className="text-honey" />
            <p className="eyebrow m-0">Pilares</p>
          </div>
          <h2 className="font-display font-medium text-[clamp(24px,3vw,32px)] mb-8">
            Dos pilares, inseparables
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="mod-card"><div className="font-display text-4xl text-teal-deep opacity-70 mb-2">01</div><h3 className="font-display text-[20px]">{t("site.pillar1_title")}</h3><p className="text-muted text-[14px] mt-3">{t("site.pillar1_desc")}</p></div>
            <div className="mod-card"><div className="font-display text-4xl text-teal-deep opacity-70 mb-2">02</div><h3 className="font-display text-[20px]">{t("site.pillar2_title")}</h3><p className="text-muted text-[14px] mt-3">{t("site.pillar2_desc")}</p></div>
          </div>
        </div>
      </section>
      <section className="py-24 border-t border-line" style={{ background: "#0A3F33" }}>
        <div className="wrap text-center text-white">
          <p className="eyebrow" style={{ color: "#C2872C" }}>{t("about.quote_eye")}</p>
          <h2 className="font-display font-medium text-[clamp(26px,4vw,38px)] mt-4 max-w-[24ch] mx-auto leading-tight">
            {t("about.quote")}
          </h2>
          <p className="text-honey mt-3 font-mono text-[12px] uppercase tracking-widest">{t("about.quote_by")}</p>
          <p className="text-[15px] mt-5 opacity-85 max-w-[36em] mx-auto">{t("about.quote_desc")}</p>
          <a href="mailto:info@chiessainstitute.com" className="btn mt-8" style={{ background: "#C2872C", borderColor: "#C2872C" }} data-testid="site-about-mail">
            {t("site.cta_btn")}
          </a>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
